import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#3070c9",
      light: "#e3f2fd",
      dark: "#004ba0",
      contrastText: "#fff",
    },
  },
  typography: {
    fontSize: 13,
    fontFamily: `'Inter', sans-serif`,
  },
  components: {
    MuiButton: {
      defaultProps: {
        size: "small",
      },
      styleOverrides: {
        root: {
          textTransform: "none", // disables uppercase
        },
      },
    },
  },
});

export default theme;
